export default __webpack_public_path__ + "static/media/onsite-hours.e56464bf.svg";